export const SESSION_STATES = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    FINISHED: "FINISHED",
};

export const QUESTION_TYPES = {
    SECTION: "surveySection",
};

export const ANSWER_TYPES = {
    // a comment only
    UNSTRUCTURED: "unstructured",
    // a 0 - 10 scale with follow up comment
    STRUCTURED: "structured",
    // a 0 - 10 scale
    STRUCTURED_ONLY: "structuredOnly",
    // multipleChoice (single and multi [allowMultipleAnswers] answer)
    MULTIPLE_CHOICE: "multipleChoice",
};

export const ANSWER_TYPE_COMPONENT_MAPPING = {
    [ANSWER_TYPES.UNSTRUCTURED]: "LSurveyAnswerUnstructured",
    [ANSWER_TYPES.STRUCTURED]: "LSurveyAnswerStructured",
    [ANSWER_TYPES.STRUCTURED_ONLY]: "LSurveyAnswerStructured",
    [ANSWER_TYPES.MULTIPLE_CHOICE]: "LSurveyAnswerMultipleChoice",
};

export const STORAGE_TOKEN_NAME = "survey_response";
